import { Controller } from '@hotwired/stimulus'

// Failure toasts stay up longer, matching the interaction autosave failure toast
const FAILURE_DELAY_MS = 10000

export default class extends Controller {
  static values = {
    message: String,
    failure: Boolean
  }

  connect() {
    if (this.messageValue) {
      const detail = { message: this.messageValue }
      if (this.failureValue) Object.assign(detail, { failure: true, delay: FAILURE_DELAY_MS })

      document.dispatchEvent(new CustomEvent('toast', { detail }))

      this.element.remove()
    }
  }
}
